import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { EntityHttpService } from '@app/core/async-services/http/versioned';
import { HotelGroups } from './hotel-group.interface';
import { UserService } from '@app/core/services';
import { ClearStateService } from '../clear-state/clear-state.service';

@Injectable({
  providedIn: 'root',
})
export class HotelGroupsService implements OnDestroy {
  private _sub: Array<Subscription> = [];
  private _subject = new BehaviorSubject<HotelGroups | null>(null);

  constructor(
    private _entityHttpService: EntityHttpService,
    private _userService: UserService,
    private _clearStateService: ClearStateService,
  ) {
    const updateHotelGroups = this.updateHotelGroupsByUserId().subscribe();
    this._sub.push(updateHotelGroups);
    this._clearStateService.clearState$.subscribe(() => this.clearState());
  }

  getHotelGroups() {
    return this._subject.asObservable();
  }

  private setHotelGroups(hotelGroups: HotelGroups) {
    this._subject.next(hotelGroups);
  }

  private clearState() {
    this._subject.next(null);
  }

  ngOnDestroy() {
    this._sub.forEach((item: Subscription) => item.unsubscribe());
  }

  private updateHotelGroupsByUserId() {
    return this._userService.getUser().pipe(
      switchMap((user) =>
        this._entityHttpService.getHotelGroupsByWebUserId(user!.WebUserId),
      ),
      map((response) => response.payload),
      tap((hotelGroups) => this.setHotelGroups(hotelGroups)),
    );
  }
}
